// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1pn-h","productName":"Table_productName__Q67pP"};